import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, timer  } from 'rxjs';
import { Router } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { urlApi } from '../../../utils/apiConfig';
@Injectable({
  providedIn:'root'
})
export class AuthServiceService {
  public urlApi!:string;
  constructor(private http: HttpClient, private router: Router, ) {
   
   }

  public authService(): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(urlApi + '/app/verifyLogged', null, {
      // headers: { 'Authorization': localStorage.getItem('token') ?? '' },
      observe: 'response' 
    });
  }

  requestDataPeriodically(): Observable<any> {
    return timer(0, 180000).pipe(
      switchMap(() => this.http.post(urlApi+'/app/verifyLogged', null))
    );
  }

  public logout(){
    localStorage.clear();
    this.router.navigate(['/']);
  }
}
